<script>
import isUndefined from 'lodash/isUndefined';
import isObject from 'lodash/isObject';
import { generate } from 'randomstring';

export default {
  props: {
    label: String,
    model: [Boolean, Array],
    value: {
      type: [String, Boolean],
      default: undefined,
    },
    disabled: [String, Boolean],
    checkboxId: String,
    error: String,
    errorVisible: Boolean,
    bold: [Boolean, String],
    small: [Boolean, String],
  },
  data: () => ({
    isUndefined,
  }),
  computed: {
    id() {
      return this.checkboxId || `checkbox_${generate()}`;
    },
    errorId() {
      return generate();
    },
    checked: {
      get() {
        return this.model;
      },
      set(e) {
        this.emitInput(e);
      },
    },
  },
  methods: {
    emitInput(e) {
      if (!this.disabled) {
        if (isObject(e)) {
          this.$emit('input', this.value || !this.model)
        } else {
          this.$emit('input', e);
        }
      }
    },
  },
};
</script>

<template lang='pug'>
div
  label.text-xl.md_text-base.relative.cursor-pointer.select-none.form-input.block.pl-2_25.md_pl-1_75(
    :class='{ "form-input--radio": !isUndefined(value), "font-bold": bold, "form-input--small": small }',
  ) {{label}}
    input.absolute.opacity-0.cursor-pointer.h-0.w-0(
      v-if='isUndefined(value)',
      tabindex='-1',
      v-model='checked',
      type='checkbox',
      :id='id',
      :disabled='disabled',
    )
    input.absolute.opacity-0.cursor-pointer.h-0.w-0(
      v-else,
      tabindex='-1',
      type='radio',
      v-model='checked',
      :id='id',
      :disabled='disabled',
      :value='value',
    )
    span.absolute.top-0.left-0.h-full.bg-white.border-brand-secondary-200.border.rounded.form-input__mark(
      tabindex='0',
      :role='isUndefined(value) ? "checkbox": "radio"',
      :aria-label='label',
      :aria-describedby='error && errorVisible ? errorId : null',
      :aria-invalid='error ? "true" : "false"',
      :aria-checked='checked ? "true" : "false"',
      :aria-disabled='disabled ? "true" : "false"',
      @keyup.enter='emitInput',
    )

  .mt-_5.text-error(
    v-if='error && errorVisible',
    :id='errorId',
  ) {{error}}
</template>

<style>
@import '~import/index';

.form-input {
  $self: &;
  line-height: 1.5rem;

  >span {
    height: 1.5rem;
  }

  @include mq(mf-md) {
    line-height: 1.25rem;

    >span {
      height: 1.25rem;
    }
  }

  &:hover>input~#{$self}__mark {
    border-color: $primaryColor;
  }

  >input:checked~#{$self}__mark {
    background-color: $primaryColor;
    border-color: $primaryColor;
  }

  &__mark {
    width: 1.5rem;

    @include mq(mf-md) {
      width: 1.25rem;
    }

    &:after {
      content: "";
      position: absolute;
      display: none;
    }
  }

  >input:checked~#{$self}__mark:after {
    display: block;
  }

  >#{$self}__mark:after {
    left: 50%;
    top: 45%;
    width: .5rem;
    height: .75rem;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &--radio {
    >input:checked~#{$self}__mark {
      background-color: transparent;
    }

    >#{$self}__mark {
      border-radius: 50%;

      &:after {
        top: 50%;
        left: 50%;
        width: .85rem;
        height: .85rem;
        background: $primaryColor;
        border-radius: 50%;
        border: none;
        transform: translate(-50%, -50%);

        @include mq(mf-md) {
          width: .75rem;
          height: .75rem;
        }
      }
    }
  }

  &--small {
    line-height: 1.25rem;

    >span {
      height: 1.25rem;
    }

    @include mq(mf-md) {
      >span {
        height: 1rem;
      }

      line-height: 1rem;
    }

    >#{$self}__mark {
      width: 1.25rem;

      @include mq(mf-md) {
        width: 1rem;
      }

      &:after {
        width: .4rem;
        height: .6rem;
      }
    }

    &#{$self}--radio>#{$self}__mark:after {
      width: .7rem;
      height: .7rem;
    }
  }
}
</style>